import { MaskedLine } from "./Reveal";

export const PageHero = ({ overline, title, accent, description, image }) => (
  <section className="relative flex min-h-[54vh] items-end overflow-hidden bg-navy-900" data-testid="page-hero">
    <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-55" />
    <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/40 to-navy-950/20" />
    <div className="relative mx-auto w-full max-w-7xl px-6 pb-16 pt-40 lg:px-10">
      <MaskedLine>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold-400 sm:text-sm">{overline}</p>
      </MaskedLine>
      <h1 className="mt-4 max-w-3xl font-serif text-3xl font-light leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
        <MaskedLine delay={0.12}>{title}</MaskedLine>
        {accent && (
          <MaskedLine delay={0.24}>
            <span className="italic text-gold-400">{accent}</span>
          </MaskedLine>
        )}
      </h1>
      {description && (
        <MaskedLine delay={0.36}>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">{description}</p>
        </MaskedLine>
      )}
    </div>
  </section>
);
